import { UseFormWatch } from 'react-hook-form';
import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCard/ProgramActivityCard.types';
import { useMutationDownloadExternalDocument } from 'api/mutations/downloadExternalDocument.mutation';

import { useMobileStore } from 'store/mobile.store';
import { LinksViewDesktop } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/AssociatedDocuments/components/LinksView/desktop/LinksView.desktop';
import { LinksViewMobile } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/AssociatedDocuments/components/LinksView/mobile/LinksView.mobile';
import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';

interface Props {
    watch: UseFormWatch<IFields>;
    handleDeleteAssociatedDocumentsLinks: (index: number) => void;
    handleDeleteAssociatedDocuments: (id: number) => void;
}

export const LinksView = ({ watch, handleDeleteAssociatedDocumentsLinks, handleDeleteAssociatedDocuments }: Props) => {
    const { mutate: downloadExternalDocumentMutate } = useMutationDownloadExternalDocument();
    const isMobile = useMobileStore((state) => state.isMobile);
    const { handleSnackBar } = useCustomSnackBar();

    const handleDownloadExternalDocument = (documentId: number, fileName: string) => {
        downloadExternalDocumentMutate(
            {
                documentId,
                fileName,
            },
            {
                onError: (error) => {
                    DEFAULT_ERROR({ error, handleError: handleSnackBar });
                },
            },
        );
    };

    const componentProps = {
        handleDownloadExternalDocument,
        watch,
        handleDeleteAssociatedDocumentsLinks,
        handleDeleteAssociatedDocuments,
    };

    return isMobile ? <LinksViewMobile {...componentProps} /> : <LinksViewDesktop {...componentProps} />;
};
